import classNames from 'classnames'
import BaseTooltip from 'components/BaseTooltip'
import ClipboardTextIcon from 'mdi-react/ClipboardTextIcon'
import React, { useCallback } from 'react'
import { makeStyles } from 'tss-react/mui'

import { IconButton, Theme } from '@mui/material'

export type CopyToClipboardProps = {
  className?: string
  textToCopy: string
  tooltipText?: string
}

export const CopyToClipboard = React.memo(({ className, textToCopy, tooltipText }: CopyToClipboardProps) => {
  const { classes } = useStyles()
  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(textToCopy)
  }, [textToCopy])

  return (
    <BaseTooltip title={!!tooltipText ? tooltipText : 'Copy to clipboard'} bottom>
      <IconButton className={classNames(className, classes.copyButton)} onClick={handleCopy}>
        <ClipboardTextIcon className={classes.iconInButton} />
      </IconButton>
    </BaseTooltip>
  )
})

CopyToClipboard.displayName = 'CopyToClipboard'

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  copyButton: {
    padding: spacing(0.75),
  },
  iconInButton: {
    width: spacing(2),
    height: spacing(2),
  },
}))
